import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class RelativeDensityTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (RelativeDensityTypeModel._instance == null) RelativeDensityTypeModel._instance = new RelativeDensityTypeModel(authManager);
        return RelativeDensityTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/relative-density-types', 'geo-sections/relative-density-types/codelist');

        this.entityName = 'geo-sections.RelativeDensityType';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Relative Density Type';
        this.setLabel = 'Relative Density Types';

        this.browser = {
            name: 'default-geo-sections-relativedensitytype-browser',
            moduleName: 'default-geo-sections-relativedensitytype-browser',
            moduleTitle: 'Relative Density Types',
            moduleStateSlotName: 'default-geo-sections-relativedensitytype-browser',
        };

        this.editor = {
            name: 'default-geo-sections-relativedensitytype-editor',
            moduleName: 'default-geo-sections-relativedensitytype-editor',
            moduleTitle: 'Relative Density Type',
            moduleStateSlotName: 'default-geo-sections-relativedensitytype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'codeStandardDocumentId',
                type: 'CodeStandardDocument',
                persistent: true,
                label: 'Code Standard Document',
            },
            {
                name: 'notesEn',
                type: 'string',
                persistent: true,
                label: 'Notes En',
            },
            {
                name: 'notesCz',
                type: 'string',
                persistent: true,
                label: 'Notes Cz',
            },
        ];

    }

}
